var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pretty-json',{attrs:{"json":_vm.recursivelyParseSchema(_vm.model)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }